<template>
  <tg-tool-layout>
    <template v-if="isMobile"></template>
    <template v-else>
      <tg-date-search v-model="dateRange" showDateRangePicker></tg-date-search>
    </template>
  </tg-tool-layout>
</template>

<script>
// import TgDateRadio from "@/components/form/TgDateRadio";
// import TgDateDropdown from "@/components/form/TgDateDropdown";
// import TgDatePicker from "@/components/form/TgDatePicker";
import TgDateSearch from "@/components/datePicker/TgDateSearch";
import TgToolLayout from "@/layout/TgToolLayout";

export default {
  components: {
    TgToolLayout,
    TgDateSearch
    // TgDatePicker,
    // // TgDateRadio,
    // TgDateDropdown
  },
  data() {
    return {
      dateRange: {
        startDate: "",
        endDate: ""
      }
    };
  },
  props: {
    value: [Object, String]
  },
  created() {
    if (this.value) {
      this.dateRange = this.value;
    }
  },
  mounted() {
    this.$emit("input", this.dateRange);
  },
  watch: {
    dateRange(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.dateRange = val;
    }
  }
};
</script>
